// #region Imports
import { useRef, useEffect } from 'react';
import './AZFeedback.css';
// #endregion

// #region Types
interface TimeLineProps {
  steps: string[];
  currentStep: number;
}
// #endregion

// #region Component
const TimeLine = ({ steps, currentStep }: TimeLineProps) => {
  const stepRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const activeRef = stepRefs.current[currentStep];
    if (activeRef) {
      activeRef.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }, [currentStep]);

  return (
    <div className="az-feedback-timeline" role="list" aria-label="Progress">
      {steps.map((step, index) => {
        const isActive = index === currentStep;
        const isDone = index < currentStep;

        return (
          <div
            key={step}
            ref={(el) => { stepRefs.current[index] = el; }}
            className="az-feedback-timeline-step"
            role="listitem"
            aria-current={isActive ? 'step' : undefined}
            data-active={isActive || undefined}
            data-done={isDone || undefined}
          >
            <div className="az-feedback-timeline-circle" aria-hidden="true">
              {index + 1}
            </div>
            <span className="az-feedback-timeline-label">{step}</span>
          </div>
        );
      })}
    </div>
  );
};
// #endregion

// #region Display Name
TimeLine.displayName = 'TimeLine';
// #endregion

export { TimeLine };
